import { previewKeyAtom } from 'js/file_viewer/core/atoms/atom';
/**
 * The locally calculated dimensions for an image (if any), which is potentially different than riviera supplied
 * dimensions
 */
export const imageLocalDimensionsAtom = previewKeyAtom(undefined);
//# sourceMappingURL=image.preenvesnextjs.map
